import React from 'react'
import { useRoutes } from 'react-router-dom'
import Hero from './Hero'
import Register from "./Register"

const Allroutes = () => {
    let element = useRoutes([
        {
            path: "/",
            element: <Hero />
        },
        {
            path: "/register",
            element: <Register />
        }
    ])
  return element
}

export default Allroutes